/*
 * @Author: Teemo Ding
 * @Date: 2021-08-12 14:10:21
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-12 14:54:12
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/Components/AddComment/index.tsx
 */
import { ModalFooter } from '@/src/components/Antd';
import React, { useState } from 'react';
import Editor from 'src/constrains/BraftEditor';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const AddComment = ({ confirm, onCancel }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [content, setContent] = useState('');

  return (
    <div className={css.container}>
      <Editor
        linkSet={''}
        data={content}
        onChange={({ data }) => {
          setContent(data);
          // handleOnStaticChange({ content: data });
          //   console.log(data);
        }}
      />
      <ModalFooter
        onOk={() => confirm(content)}
        onText={getI18n('general.confirm')}
        onCancel={onCancel}
      />
    </div>
  );
};

export default AddComment;
